<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Editar Localização (Origem/Destino)</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div class="mt-8 mb-0">
    <div [formGroup]="form">
      <div class="flex justify-between gap-4 items-center">
        <mat-form-field class="input-tg w-full" appearance="outline">
          <mat-label>Descrição</mat-label>
          <input matInput formControlName="description" />
        </mat-form-field>
      </div>
      <div class="flex justify-start gap-4 items-center">
        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>País</mat-label>
          <input matInput formControlName="country" />
        </mat-form-field>

        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>Estado</mat-label>
          <input
            matInput
            formControlName="state"
            [matAutocomplete]="autoEstado"
            placeholder="Selecione o estado"
          />
          <mat-autocomplete #autoEstado="matAutocomplete" [displayWith]="displayEstado">
            <mat-option *ngFor="let estado of estadosFiltrados$ | async" [value]="estado">
              {{ estado.estado }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="input-tg w-4/12" appearance="outline">
          <mat-label>Cidade</mat-label>
          <input
            matInput
            formControlName="city"
            [matAutocomplete]="autoCidade"
            placeholder="Selecione a cidade"
          />
          <mat-autocomplete #autoCidade="matAutocomplete">
            <mat-option *ngFor="let cidade of cidadesFiltradas$ | async" [value]="cidade">
              {{ cidade }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>

    <div class="flex justify-end mt-3">
      <button
        mat-flat-button
        class="btn-tg w-1/5"
        [disabled]="!form.valid || loading"
        (click)="editLocation()"
      >
        @if (loading) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          Editar
        }
      </button>
    </div>
  </div>
</mat-card>
